<mat-slider [ngClass]="styleClass ?? ''">
  <input matSliderThumb [min]="minValue" [max]="maxValue" [step]="stepSize" [value]="currentStep" (valueChange)="onMatSliderChange($event)">
</mat-slider>
